import {
  Remuneracao,
  IndexadorRemuneracao,
  PeriodicidadeCorrecao,
  TipoProRata,
  TipoProjecao,
  ConvencaoJurosFixo,
} from 'common/genericTypes';
import {
  booleanOptions,
  BooleanValue,
  convencaoJurosFixosOptions,
  defasagemFixingAnualOptions,
  defasagemFixingDiarioOptions,
  defasagemFixingMensalOptions,
  indexadorRemuneracaoOptions,
  monthDayOptions,
  monthOptions,
  Option,
  periodicidadeCorrecaoOptions,
  tipoProjecaoOptions,
  tipoProRataOptions,
} from 'common/genericOptions';
import { Dropdown, NumberField, Section } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import { selectOption } from 'common/genericOptions';
import { useDispatch } from 'react-redux';
import { convencaoJurosDescritivo } from 'utils/convencaoTaxaDescritivo';
import InfoIcon from '@material-ui/icons/Info';
import { labelsCriteriosRemuneracao as labels } from 'common/registro/labels';
import { EtapaCadastro } from 'common/registro/enums';

interface RemuneracaoSectionProps {
  remuneracao: Remuneracao;
  onUpdateRemuneracaoField: (field: any) => void;
  useValidarCampos: Function;
  highlightErrors: boolean;
  updateRemuneracao: Function;
}

export const RemuneracaoSection: React.FC<RemuneracaoSectionProps> = (props) => {
  const {
    onUpdateRemuneracaoField,
    remuneracao,
    remuneracao: { indexador, periodicidadeCorrecao },
    useValidarCampos,
    highlightErrors,
    updateRemuneracao,
  } = props;
  const [defasagemFixingSpecificOptions, setDefasagemFixingOptions] = useState<Array<Option>>([]);
  const [requiredIndexadorPorcentagem, setRequiredIndexadorPorcentagem] = useState<boolean>(false);
  const [showIndexadorPorcentagem, setShowIndexadorPorcentagem] = useState<boolean>(false);
  const [showPeriodicidadeCorrecao, setShowPeriodicidadeCorrecao] = useState<boolean>(false);
  const [showProRata, setShowProRata] = useState<boolean>(false);
  const [showCorrigePeriodoFinal, setShowCorrigePeriodoFinal] = useState<boolean>(false);
  const [showDiaAniversario, setShowDiaAniversario] = useState<boolean>(false);
  const [showMesAniversario, setShowMesAniversario] = useState<boolean>(false);
  const [showTipoProjecao, setShowTipoProjecao] = useState<boolean>(false);
  const [requiredTaxaJurosFixoSpreadPorcentagem, setRequiredtaxaJurosFixoSpreadPorcentagem] = useState<boolean>(false);
  const [requiredConvencao, setRequiredConvencao] = useState<boolean>(false);
  const [descritivoConvencaoTaxa, setDescritivoConvencaoTaxa] = useState<string>();
  const camposInvalidos = useValidarCampos(EtapaCadastro.CriteriosRemuneracao);

  const showError = (label: string) => camposInvalidos.includes(label) && highlightErrors;
  const dispatch = useDispatch();

  function setDefaultValues(novoIndexador: IndexadorRemuneracao | undefined) {
    switch (novoIndexador) {
      case IndexadorRemuneracao.TR:
      case IndexadorRemuneracao.Prefixado:
        dispatch(
          updateRemuneracao({
            ...remuneracao,
            corrigePeriodoFinal: undefined,
            defasagemFixing: undefined,
            diaAniversario: undefined,
            indexadorPorcentagem: undefined,
            mesAniversario: undefined,
            periodicidadeCorrecao: undefined,
            proRata: undefined,
            tipoProjecao: undefined,
          })
        );
        break;
      case IndexadorRemuneracao.CDI:
      case IndexadorRemuneracao.Selic:
        dispatch(
          updateRemuneracao({
            ...remuneracao,
            corrigePeriodoFinal: undefined,
            diaAniversario: undefined,
            mesAniversario: undefined,
            periodicidadeCorrecao: undefined,
            proRata: undefined,
            tipoProjecao: undefined,
          })
        );
        break;
      case IndexadorRemuneracao.IGPM:
      case IndexadorRemuneracao.IPCA:
        dispatch(
          updateRemuneracao({
            ...remuneracao,
          })
        );
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    setRequiredIndexadorPorcentagem(false);
    setShowPeriodicidadeCorrecao(false);
    setShowProRata(false);
    setShowDiaAniversario(false);
    setShowTipoProjecao(false);
    setRequiredtaxaJurosFixoSpreadPorcentagem(false);
    setRequiredConvencao(false);
    setShowIndexadorPorcentagem(false);

    switch (indexador) {
      case IndexadorRemuneracao.TR:
      case IndexadorRemuneracao.Prefixado:
        setRequiredtaxaJurosFixoSpreadPorcentagem(true);
        setRequiredConvencao(true);
        break;
      case IndexadorRemuneracao.CDI:
      case IndexadorRemuneracao.Selic:
        setRequiredIndexadorPorcentagem(true);
        setShowIndexadorPorcentagem(true);
        break;
      case IndexadorRemuneracao.IGPM:
      case IndexadorRemuneracao.IPCA:
        setShowPeriodicidadeCorrecao(true);
        setShowProRata(true);
        setShowDiaAniversario(true);
        setShowTipoProjecao(true);
        setShowIndexadorPorcentagem(true);
        break;
    }

    setDefaultValues(indexador);
  }, [indexador]);

  useEffect(() => {
    setShowCorrigePeriodoFinal(false);
    setShowMesAniversario(false);

    switch (indexador) {
      case IndexadorRemuneracao.CDI:
      case IndexadorRemuneracao.Selic:
        setDefasagemFixingOptions([selectOption, ...defasagemFixingDiarioOptions]);
        break;
      case IndexadorRemuneracao.IGPM:
      case IndexadorRemuneracao.IPCA:
        switch (periodicidadeCorrecao) {
          case PeriodicidadeCorrecao.Mensal:
            setDefasagemFixingOptions([selectOption, ...defasagemFixingMensalOptions]);
            break;
          case PeriodicidadeCorrecao.Anual:
            setShowCorrigePeriodoFinal(true);
            setDefasagemFixingOptions([selectOption, ...defasagemFixingAnualOptions]);
            setShowMesAniversario(true);
            break;
          case PeriodicidadeCorrecao.Diario:
            setDefasagemFixingOptions([selectOption, ...defasagemFixingDiarioOptions]);
            break;
        }
        break;
      default:
        setDefasagemFixingOptions([]);
        break;
    }
  }, [indexador, periodicidadeCorrecao]);

  return (
    <Section title={'Remuneração'} defaultGrid>
      <Dropdown
        label={labels.indexador}
        value={(remuneracao.indexador ?? '') as string}
        options={indexadorRemuneracaoOptions}
        onChange={(value) =>
          onUpdateRemuneracaoField({
            name: 'indexador',
            value: value as IndexadorRemuneracao,
          })
        }
        required
        error={showError(labels.indexador)}
      />
      {showIndexadorPorcentagem && (
        <NumberField
          label={labels.indexadorPorcentagem}
          value={remuneracao.indexadorPorcentagem ?? null}
          onChange={(value) => {
            onUpdateRemuneracaoField({
              name: 'indexadorPorcentagem',
              value,
            });
          }}
          numberType="eightDecimals"
          adornment={'%'}
          adornmentPosition={'end'}
          required={requiredIndexadorPorcentagem}
          error={showError(labels.indexadorPorcentagem)}
        />
      )}
      {defasagemFixingSpecificOptions && defasagemFixingSpecificOptions.length > 0 && (
        <Dropdown
          label={labels.defasagemFixing}
          value={(remuneracao.defasagemFixing ?? '') as string}
          options={defasagemFixingSpecificOptions}
          onChange={(value) =>
            onUpdateRemuneracaoField({
              name: 'defasagemFixing',
              value: value === '' ? undefined : (value as IndexadorRemuneracao),
            })
          }
          required
          error={showError(labels.defasagemFixing)}
        />
      )}
      {showPeriodicidadeCorrecao && (
        <Dropdown
          label={labels.periodicidadeCorrecao}
          value={(remuneracao.periodicidadeCorrecao ?? '') as string}
          options={periodicidadeCorrecaoOptions}
          onChange={(value) =>
            onUpdateRemuneracaoField({
              name: 'periodicidadeCorrecao',
              value: value === '' ? undefined : (value as PeriodicidadeCorrecao),
            })
          }
          required
          error={showError(labels.periodicidadeCorrecao)}
        />
      )}
      {showProRata && (
        <Dropdown
          label={labels.proRata}
          value={(remuneracao.proRata ?? '') as string}
          options={tipoProRataOptions}
          onChange={(value) =>
            onUpdateRemuneracaoField({
              name: 'proRata',
              value: value === '' ? undefined : (value as TipoProRata),
            })
          }
          required
          error={showError(labels.proRata)}
        />
      )}
      {showCorrigePeriodoFinal && (
        <Dropdown
          label={labels.corrigePeriodoFinal}
          value={remuneracao.corrigePeriodoFinal ? BooleanValue.Yes : BooleanValue.No}
          options={booleanOptions}
          onChange={(value) =>
            onUpdateRemuneracaoField({
              name: 'corrigePeriodoFinal',
              value: (value as BooleanValue) === BooleanValue.Yes,
            })
          }
          required
          error={showError(labels.corrigePeriodoFinal)}
        />
      )}
      {showDiaAniversario && (
        <Dropdown
          label={labels.diaAniversario}
          required
          options={monthDayOptions}
          value={remuneracao.diaAniversario ? `${remuneracao.diaAniversario}` : ''}
          onChange={(value) => {
            onUpdateRemuneracaoField({
              name: 'diaAniversario',
              value: +value,
            });
          }}
          error={showError(labels.diaAniversario)}
        />
      )}
      {showMesAniversario && (
        <Dropdown
          label={labels.mesAniversario}
          required
          options={monthOptions}
          value={remuneracao.mesAniversario ? `${remuneracao.mesAniversario}` : ''}
          onChange={(value) => {
            onUpdateRemuneracaoField({
              name: 'mesAniversario',
              value: +value,
            });
          }}
          error={showError(labels.mesAniversario)}
        />
      )}
      {showTipoProjecao && (
        <Dropdown
          label={labels.tipoProjecao}
          required
          options={tipoProjecaoOptions}
          value={(remuneracao.tipoProjecao ?? '') as string}
          onChange={(value) => {
            onUpdateRemuneracaoField({
              name: 'tipoProjecao',
              value: value as TipoProjecao,
            });
          }}
          error={showError(labels.tipoProjecao)}
        />
      )}
      <NumberField
        label={labels.taxaJurosFixoSpreadPorcentagem}
        value={remuneracao.taxaJurosFixoSpreadPorcentagem ?? null}
        onChange={(value) => {
          onUpdateRemuneracaoField({
            name: 'taxaJurosFixoSpreadPorcentagem',
            value,
          });
        }}
        numberType="eightDecimals"
        adornment={'%'}
        adornmentPosition={'end'}
        required={requiredTaxaJurosFixoSpreadPorcentagem}
        acceptZero={true}
      />
      <Dropdown
        label={labels.convencao}
        required={requiredConvencao}
        options={convencaoJurosFixosOptions}
        value={(remuneracao.convencao ?? '') as string}
        onChange={(value) => {
          onUpdateRemuneracaoField({
            name: 'convencao',
            value: value as ConvencaoJurosFixo,
          });
          setDescritivoConvencaoTaxa(convencaoJurosDescritivo(value as ConvencaoJurosFixo));
        }}
        error={showError(labels.convencao)}
      />
      <span> <InfoIcon /> {descritivoConvencaoTaxa}</span>
    </Section>
  );
};
